export default __webpack_public_path__ + "images/0x78354f8dccb269a615a7e0a24f9b0718fdc3c7a7.png";